import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('bringozFullDate', bringozFullDate);

function bringozFullDate(splitService, moment) {
  return function bringozFullDateFilter(object, ref, defaultValue, ignoreSite) {
    if (object && object[ref]) {
      const format = splitService.getDateAndTimeConfig(ignoreSite).fullDate;
      return moment(object[ref]).format(format);
    } else {
      return defaultValue;
    }
  }
}
